const setUserMeta = (state, payload) => state.userMeta = payload;

export default {
    setUserMeta,
};